( function( app ) {
  const COMPONENT = {
    init: function() {
      const bar = document.querySelector( '[data-component="jump-link-bar"]' );
      if ( !bar ) return;

      const links = [...bar.querySelectorAll( '.jump-link-bar__link' )];
      if ( !links.length ) return;

      const toggleLabel = bar.querySelector( '.jump-link-bar__toggle-label' );

      // Build map: anchor id -> link elements (both mobile + desktop share the same href)
      const linkMap = new Map(
          links
              .map( ( link ) => [link.getAttribute( 'href' )?.slice( 1 ), link] )
              .filter( ( [id] ) => id && document.getElementById( id ) ),
      );

      if ( !linkMap.size ) return;

      const getTopOffset = () => {
        const header = document.querySelector( 'header' )?.offsetHeight ?? 0;
        const adminBar = document.getElementById( 'wpadminbar' )?.offsetHeight ?? 0;
        return header + adminBar;
      };

      const setActive = ( id ) => {
        links.forEach( ( link ) => {
          const isActive = link.getAttribute( 'href' )?.slice( 1 ) === id;
          link.classList.toggle( 'is-active', isActive );
          link.setAttribute( 'aria-current', isActive ? 'true' : 'false' );
        } );

        // Keep the mobile toggle button label in sync
        if ( toggleLabel && id ) {
          const activeLink = bar.querySelector( `.jump-link-bar__link[href="#${id}"]` );
          if ( activeLink ) toggleLabel.textContent = activeLink.textContent.trim();
        }
      };

      let observer;

      const buildObserver = () => {
        if ( observer ) observer.disconnect();

        const topPx = getTopOffset();

        observer = new IntersectionObserver(
            ( entries ) => {
              entries.forEach( ( entry ) => {
                if ( entry.isIntersecting ) setActive( entry.target.id );
              } );
            },
            {
              // Exclude the navbar area from the top; treat only the upper ~45% as "active"
              rootMargin: `-${topPx}px 0px -55% 0px`,
              threshold: 0,
            },
        );

        linkMap.forEach( ( _link, id ) => {
          const target = document.getElementById( id );
          if ( target ) observer.observe( target );
        } );
      };

      buildObserver();

      window.addEventListener( 'resize', buildObserver, {passive: true} );
    },
    finalize: function() {},
  };

  app.registerComponent( 'jump-link-bar', COMPONENT );
} )( app );
